let state = {};

/**
 * Returns immutable state
 *
 * @returns {object} state
 */
export function get() {
  return Object.assign({}, state);
}

/**
 * Sets state
 *
 * @param {object} newState
 * @returns {object} state
 */
export function set(newState) {
  state = newState;
  return get();
}

/**
 * Updates state
 *
 * @param {Function} updater Function which receives old state as
 *                           an argument and returns new state
 * @returns {object} state
 */
export function update(updater) {
  state = updater(state);
  return get();
}

export default {
  set,
  update,
  get values() {
    return get();
  }
};
